// extracted by mini-css-extract-plugin
module.exports = {"error":"PortalPage__error--17o","content":"PortalPage__content--3rT"};